import BMLogoBig from "./images/typeapp-logo-big.png";
import BLLogoBig from "./images/bluemail-logo-big.png";
import BPLogoBig from "./images/bluemailplus-logo-big.png";
import EBLogoBig from './images/ultima-logo-big.png';
import BXLogoBig from './images/blix-logo-big.png';
import BMLogo from "./images/typeapp-logo.png";
import BLLogo from "./images/bluemail-logo.png";
import BPLogo from "./images/bluemailplus-logo.png";
import EBLogo from './images/ultima-logo.png';
import BXLogo from './images/blix-logo.png';
import BLFavicon from './images/bluemail-favicon.png';
import BPFavicon from './images/bluemailplus-favicon.png';
import EBFavicon from './images/ultima-favicon.png';
import BMFavicon from './images/typeapp-favicon.png';
import BXFavicon from './images/blix-favicon.png';
import TypeAppTheme from "./typeapp-theme";
import UltimaTheme from "./ultimahq-theme";
import BlueMailTheme from "./bluemail-theme";
import BlixTheme from "./blix-theme";

export function inIframe() {
    try {
        return window.self !== window.top;
    } catch (e) {
        console.error('inIframe ' + e);
        return true;
    }
}

export function inPopUp() {
    try {
        return window.opener && window.opener !== window;
    } catch (e) {
        console.error('inPopUp ' + e);
        return false;
    }
}

export function getAppProps(brand) {
    const appProps = {};
    if (brand && brand.id) {
        switch (brand.id) {
            case 'BM': {
                appProps.favIcon = BMFavicon;
                appProps.logo = BMLogo;
                appProps.logoBig = BMLogoBig;
                appProps.theme = TypeAppTheme;
                break
            }
            case 'EB': {
                appProps.favIcon = EBFavicon;
                appProps.logo = EBLogo;
                appProps.logoBig = EBLogoBig;
                appProps.theme = UltimaTheme;
                break
            }
            case 'BX': {
                appProps.favIcon = BXFavicon;
                appProps.logo = BXLogo;
                appProps.logoBig = BXLogoBig;
                appProps.theme = BlixTheme;
                break
            }
            case 'BP': {
                appProps.favIcon = BPFavicon;
                appProps.logo = BPLogo;
                appProps.logoBig = BPLogoBig;
                appProps.theme = BlueMailTheme;
                break
            }
            case 'BL':
            default: {
                appProps.favIcon = BLFavicon;
                appProps.logo = BLLogo;
                appProps.logoBig = BLLogoBig;
                appProps.theme = BlueMailTheme;
            }
        }
    } else {
        appProps.favIcon = BLFavicon;
        appProps.logo = BLLogo;
        appProps.logoBig = BLLogoBig;
        appProps.theme = BlueMailTheme;
    }
    return appProps;
}


// WEBPACK FOOTER //
// ./src/utils.js